<template>

  <v-container fluid>

    <!-- 업로드 프로그레스 -->
    <comloading :isVisible="progress_dialog" :progress="progress_value" />

    <!-- 이미지 크롭 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="crop_dialog" @keydown.esc="cancel_crop" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t("common_crop")}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="cancel_crop"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <div style="width:100%;height:500px;">

              <vue-cropper
                  ref="cropper_land"
                  :src="imgSrc"
                  :aspect-ratio="option.autoCropWidth/option.autoCropHeight"
                  />

            </div>
            
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="cancel_crop">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="cropimg">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>    

    <!-- 추가버튼 + 다이얼로그 -->
    <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="500px">
      <v-card class="dialog_round pa-10">

        <v-row dense align="center">
          <v-col cols="11" md="11" sm="11" xs="11">
            <span class="dialog_title">{{ dialogTitle }}</span>
          </v-col>
          <v-col cols="1" md="1" sm="1" xs="1">
            <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
          </v-col>
        </v-row>

        <v-row dense justify="center">
          <v-col cols="12" md="12" sm="12" xs="12">
            <div style="background:#4e6ef7;height:2px;" />
          </v-col>
        </v-row>

        <v-card-text>
          <v-container>

            <v-row dense>
              <v-col md="12" sm="12" xs="12">
                <v-text-field v-model="editedItem.TITLE" :label="$t('eventnotice_col1')" single-line></v-text-field>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col md="12" sm="12" xs="12">
                <v-select v-model="editedItem.STATE" :items="STATELIST" :label="$t('adminbanner_col3')" 
                  :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"
                  />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col md="12" sm="12" xs="12">
                <v-select v-model="editedItem.LAN_TYPE" :items="LANTYPELIST" :label="$t('adminbanner_col8')" 
                  :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"
                  />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col md="12" sm="12" xs="12">
                <div class="input_title w-100">{{$t('adminbanner_label11')}}</div>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="12" sm="12" xs="12">
                <div class="mt-1" style="height:140px">
                  <div style="cursor:pointer;height:120px;background:#eaeaea;position:relative;display:flex; align-items:center; justify-content:center;"
                    @click="fileSelect('IMAGE', 600, 800)"
                    >
                      <img 
                        height="120"
                        :src="previewImg"
                        class="image" style="cursor:pointer"
                        />
                      <v-icon 
                        style="position:absolute; bottom:8px; right:8px; cursor:pointer;"
                        >
                        mdi-pencil
                      </v-icon>
                  </div>
                </div>        
              </v-col>
            </v-row>

            <v-row dense>
              <v-col md="12" sm="12" xs="12">
                <v-text-field v-model="editedItem.LINK_URL" :label="$t('adminbanner_label6')" single-line></v-text-field>
              </v-col>
            </v-row>
            
            <v-row>
              <v-col md="12" sm="12" xs="12">
                <v-menu
                  v-model="start_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="editedItem.STARTDATE"
                      :label="$t('adminbanner_label9')"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="editedItem.STARTDATE" @input="start_date = false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
                </v-menu>                    
              </v-col>
            </v-row>
            <v-row>
              <v-col md="12" sm="12" xs="12">
                <v-menu
                  v-model="end_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="editedItem.ENDDATE"
                      :label="$t('adminbanner_label10')"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="editedItem.ENDDATE" @input="end_date = false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
                </v-menu>                    
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row justify="center">
          <v-btn class="dialog_cancel_btn mr-5" rounded large @click="close">{{$t("common_cancel")}}</v-btn>
          <v-btn class="dialog_btn" rounded large @click="save">{{ editedIndex == -1 ? $t('common_insert') : $t('common_edit') }}</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>  

    <v-row align="center" dense no-gutters>
      <v-col cols="3">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <v-col cols="3">
        <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
      </v-col>
      <v-col cols="3">
        <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>   
      <v-col cols="1" class="pa-0" align="center">
        <v-btn width="94%" class="search_btn_freesize" elevation="0" outlined large @click="newinsert">{{$t("common_insert")}}</v-btn>
      </v-col>
      <v-col cols="1" class="pa-0" align="center">
        <v-btn class="yellow_btn" elevation="0" outlined large @click="saveSort">{{$t('eventformat_label5')}}</v-btn>
      </v-col>
    </v-row>

  <v-row dense no-gutters>
    <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
  </v-row>
  <v-row align="start">
    <v-col>
      <draggable v-model="itemList">
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        class="datatablestyle"
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        >

        <template v-slot:header.IMAGE>
          <label class="cheader_normal">{{$t("adminbanner_col1")}}</label>
        </template>
        <template v-slot:header.TITLE>
          <a :class="sort_name=='TITLE'?'cheader_sortselect':'cheader_sort'" @click="customsort('TITLE')">{{$t("adminbanner_col2")}}</a>
        </template>
        <!-- 
        <template v-slot:header.DESC>
          <a :class="sort_name=='DESC'?'color:red':'cheader_sort'" @click="customsort('DESC')">설명</a>
        </template>
        -->
        <template v-slot:header.STATE>
          <a :class="sort_name=='STATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('STATE')">{{$t("adminbanner_col3")}}</a>
        </template>
        <template v-slot:header.LAN_TYPE>
          <a :class="sort_name=='LAN_TYPE'?'cheader_sortselect':'cheader_sort'" @click="customsort('LAN_TYPE')">{{$t("adminbanner_col8")}}</a>
        </template>
        <template v-slot:header.TYPE_NAME>
          <a :class="sort_name=='TYPE_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('TYPE_NAME')">{{$t("adminbanner_col4")}}</a>
        </template>
        <!-- 
        <template v-slot:header.TYPE_URL>
          <a :class="sort_name=='TYPE_URL'?'cheader_sortselect':'cheader_sort'" @click="customsort('TYPE_URL')">링크</a>
        </template>
        -->
        <template v-slot:header.STARTDATE>
          <a :class="sort_name=='STARTDATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('STARTDATE')">{{$t("adminbanner_col5")}}</a>
        </template>
        <template v-slot:header.ENDDATE>
          <a :class="sort_name=='ENDDATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('ENDDATE')">{{$t("adminbanner_col6")}}</a>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("adminbanner_col7")}}</label>
        </template>


        <template v-slot:body="props">
          <draggable :list="props.items" ghost-class="ghost" @change="changedrag" tag="tbody">
            <tr v-for="(item, index) in props.items" :key="index">
              <td style="width:50px; text-align:center"><v-icon small>mdi-drag</v-icon></td>
              <td style="max-width:100px;min-width:100px;width:100px">
                <v-img :src="item.IMAGE" contain />
              </td>
              <td style="width:200px; text-align:center">{{ item.TITLE.substring(0, 30) + "..." }}</td>
              <td style="width:100px; text-align:center">{{ item.STATE == 1 ? $t('eventlist_value1') : $t('eventlist_value2') }}</td>
              <td style="width:100px; text-align:center">{{ item.LAN_TYPE == 0 ? `${$t('emailtemp_col40')}/${$t('emailtemp_col41')}` : item.LAN_TYPE == 1 ? $t('emailtemp_col40') : $t('emailtemp_col41') }}</td>
              <td style="width:100px; text-align:center">{{ item.STARTDATE }}</td>
              <td style="width:100px; text-align:center">{{ item.ENDDATE }}</td>
              <td style="width:100px; text-align:center">
                <v-icon small @click="edit_item(item)">mdi-pencil</v-icon>
                <v-icon class="ml-3" small @click="delete_item(item)">mdi-delete</v-icon>
              </td>
            </tr>
          </draggable>
        </template>
      </v-data-table>
      </draggable>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="start">
    <v-col cols="12" md="1"/>
    <v-col cols="12" md="2">
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('common_filter')"
        single-line
        hide-details
        outlined height="43"
        color="#808080"
        dense
        />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn  icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        v-model="pagerow"
        :items="pagerow_combo"
        item-text="NAME"      
        item-value="VALUE"
        :label="$t('common_rownum')"
        min-width="150px"
        outlined height="43"
        color="#808080"
        dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="1"/>
  </v-row>

  
  

  </v-container>
</template>

<script>
import VueCropper from 'vue-cropperjs'; //이미지 크롭
import 'cropperjs/dist/cropper.css';
import draggable from 'vuedraggable'
export default {

    components:{
      draggable,
      VueCropper
    },

    data: () => ({

      progress_dialog : false,    //로딩 표시
      progress_value:0,
      
      //이미지 크롭
      crop_dialog: false,
      imgSrc:'',
      s3: null,   //aws

      uploadFile : null,
      photo_index: 0,
      previewImg: null,      //이미지 미리보기

      //신규 크롭 파라메터
      option: {
        img: "",
        outputSize: 1,
        outputType: "jpg",
        canMove: true,
        fixed: true,                  //크롭박스 비율 고정
        fixedNumber: [600, 800],    //크롭박스 비율
        fixedBox: false,      //true면 크롭박스 크기 조절 안됨
        original: false,      //true면 이미지의 원본 크기로 불러와지고 false면 편집창 기준에 맞게 불러와진다.
        canMoveBox: true,
        autoCrop: true,       //true면 자동으로 크롭박스가 표시됨.
        autoCropWidth:600,    //크롭박스의 가로 크기 fixed가 true면 비율대로
        autoCropHeight:800,   //크롭박스의 세로 크기 
        centerBox: true,
        high: false,
        cropData: {},
        enlarge: 1,
        mode: 'contain',
        maxImgSize: 5000,
        limitMinSize: [600, 800]
      },

      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      defaultItem: {
          TITLE:'',
          IMAGE:'',
          STATE:1, 
          LAN_TYPE:0,
          LINK_URL: '',
          STARTDATE: new Date().toISOString().substr(0, 10),
          ENDDATE: new Date().toISOString().substr(0, 10),
      },
      editedItem: {
      },

      //테이블 정의
      headers: [
        {text: '',  value: 'drag', sortable: false, align:'center', width:50},
        {text: '이미지',  value: 'IMAGE', sortable: false, align:'center', width:100},
        {text: '제목',    value: 'TITLE', sortable: false, align:'center', width:200},
        {text: '상태',    value: 'STATE', sortable: false, align:'center', width:80},
        {text: '노출언어',    value: 'LAN_TYPE', sortable: false, align:'center', width:100},
        {text: '시작일',    value: 'STARTDATE', sortable: false, align:'center', width:120 },
        {text: '종료일',    value: 'ENDDATE', sortable: false, align:'center', width:120 },
        {text: '수정/삭제', value: 'actions', sortable: false, align:'center', width:100}
      ],
      itemList: [],

      sort_name: 'SORT',
      sort_type: false,    //true : DESC, false: ASC

      search_keyword : '',
      search: '',         //필터링용 검색어


      //한 페이지 ROW 개수 설정
      pagerow : 10,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'10', VALUE:10}
        , {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    
         
      //추가 변수들
      STATELIST: [
          {name:'비활성', name2:"Disable", value:0}
        , {name:'활성', name2:"Enable",   value:1}
      ],
        
      LANTYPELIST: [
          {name:'한국어/영어', name2:"Kor/Eng", value:0}
        , {name:'한국어', name2:"Kor",   value:1}
        , {name:'영어', name2:"Eng",   value:2}
      ],

      start_date : false,
      end_date : false,

      grade : 0,
      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',


    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    methods: {

      //오리지널 리스트 순서를 변경
      changedrag(e){
        this.itemList.splice(e.moved.oldIndex, 1);  //원본 위치에서 제거
        this.itemList.splice(e.moved.newIndex, 0, e.moved.element);  //새로운 위치에 다시 추가
      },

      cancel_crop(){
        this.crop_dialog = false;
      },

      //이미지 크롭시
      cropimg(){

        this.crop_dialog = false;
        this.$refs.cropper_land.getCroppedCanvas().toBlob((blob) => {
          this.uploadFile = blob;
        });
        this.previewImg = this.$refs.cropper_land.getCroppedCanvas().toDataURL("image/jpeg");
        
      },

      customsort(sortname){
        this.sort_name = sortname;
        this.sort_type = !this.sort_type;
        this.loadpage(this.page);
      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.editedItem.TYPE_URL = "event://"+val1.IDX;
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.editedItem.TYPE_URL = "";
        }
        this.loadpage(1);
      },

      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = '';
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
        }
        
      },
      
      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX  = '';
          this.SEARCH_COM_NAME = '';
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
      },


      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },

      //조회
      loadpage(p){

          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/PageBannerList',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , page: this.page
              , pagerow: this.pagerow
              , COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , ADMIN_IDX:this.$session.get("ADMIN_IDX")
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{

            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
              
                this.totalcnt = result.data.totalcnt;
                this.makepaging();
                const list = result.data.resultData;
                this.itemList.splice(0, this.itemList.length);   //데이터 초기화
                list.forEach(element => {
                    this.itemList.push(element); 
                });
                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){

        //첫페이지 로드
        this.loadpage(1);
      },      

      //다이얼로그 닫기
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.uploadFile = null;
        }, 300)
      },


      fileSelect(key, width, height){

          const changefunction = this.selectfile;
          var input = document.createElement("input");
          input.style = "display:none";
          input.name = "imageinputcamera";
          input.type = "file";
          input.accept = ".jpg,.jpeg,.png"; // 확장자가 xxx, yyy 일때, ".xxx, .yyy"

          /* 크롭사이즈 변경 */
          if(width != null && height != null){
            this.option.autoCropWidth  = width;
            this.option.autoCropHeight = height;
          }

          let indexcnt = navigator.userAgent.toLowerCase().indexOf("mac os x");
          if(indexcnt > -1){
              //아이폰, 아이패드, 맥
              //input이 실제 돔에 추가되야 사진수정에 따른 onchange가 작동한다.
              document.body.appendChild(input);
              input.onchange = function (event) {
                  document.body.removeChild(input);
                  changefunction(event.target.files[0]);
              };
          }else{
              input.onchange = function (event) {
                  changefunction(event.target.files[0]);
              };
          }
          input.click();
      },                 


      //아이콘에서 파일 변경시
      selectfile(file){

        if(file.size/1024/1024 > 10){
          this.$alert(this.$t('eul_msg101'));
          this.uploadFile = null;
          return;
        }

        const reader = new FileReader();
        reader.onload = (event)=>{
            this.crop_dialog  = true;
            this.imgSrc       = event.target.result;  //이게 blob데이터
            this.$refs.cropper_land.replace(event.target.result);
        }
        reader.readAsDataURL(file);  //비동기로 파일을 읽어서

      },      

      /**
       * 이미지 업로드
       * @param {number} korname   - 업로드 구분값 (오류시 보여줌)
       * @param {number} imgparam  - 저장할 파일명 이름 
       * @returns {number} 두 숫자의 합
       */        
      async checkimgupload(korname, imgparam){
        
        const s3obj     = this.$s3;
        const folder    = this.SEARCH_COM_IDX.toString();         //중간폴더명
        var albumPhotosKey = encodeURIComponent(folder) + "/";    //중간경로명  /게 붙어야 폴더됨.
        // s3에 폴더 생성
        // eslint-disable-next-line no-unused-vars
        await s3obj.putObject({Key: albumPhotosKey}, async (err2, data2) => {
            if(err2) {
                //앨범생성 오류
                this.$alert(this.$t('eventinfo_msg16'));
                return false;
            }
        });   

        //파일이 지정된 경우
        const filevalue = this.uploadFile;
        if(filevalue){
            this.progress_dialog = true;            
            let imgpath;
            let curdate = Date.now().toString();    //무조건 신규 파일명으로 그래야 디자인 갱신됨.
            imgpath  = `${imgparam}_${curdate}.jpg`;
            
            var photoKey = albumPhotosKey + imgpath;                 //최종 경로
            const stored = await s3obj.upload({
                                                    Bucket: "blueorigin-mice-image",
                                                    Key: photoKey,
                                                    Body: filevalue,
                                                    ACL: "public-read"
                                                }).promise();

            if(stored == null || stored.Location == null){
                this.progress_dialog = false;
                this.$fire({ 
                    html:`${this.$t('common_process_fail')} <br> ${korname}`
                });
                return false;
            }
            this.progress_dialog = false;
            this.uploadFile = null;
            this.editedItem.IMAGE = stored.Location;
          
            return true;

        }else{
          //파일이 없어도 패스
          this.progress_dialog = false;
          return false;
        }

      },        


      saveSort(){

        if(this.itemList.length <= 1){
          this.$alert(this.$t('eventformat_msg1'));
          return;
        }

        var tempidx = 1;
        this.itemList.forEach(item=>{
          item.SORT = tempidx;
          tempidx++;
        });

        this.loading = true;
        this.$http.post(this.$host+'/api/PageBannerUpdateSort',
          {
            SORTDATA: escape(JSON.stringify(this.itemList))
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          this.loading = false;
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }
            this.$alert(this.$t('eventformat_msg3')).then(()=>{
              this.loadpage(1);
            });

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }else{
            this.$alert(this.$t('common_sort_fail'));
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t('common_sort_fail'));
        });

      },


      //추가 및 수정
      async save () {

        if(this.editedItem.TITLE  == undefined || this.editedItem.TITLE.length < 1){
          //alert("제목을 입력하세요");
          this.$alert(this.$t('adminbanner_msg1'));
          return;
        } 
        if(this.editedItem.TITLE.length > 50){
          this.$alert(this.$t('adminbanner_msg2'));
          return;
        } 

        const temp_start = new Date(this.editedItem.STARTDATE)
        const temp_end   = new Date(this.editedItem.ENDDATE)
        if(temp_start > temp_end){
          this.$alert(this.$t('adminbanner_msg6'));
          return;
        }

        /*
        if(this.editedItem.LINK_URL == undefined || this.editedItem.LINK_URL == null || this.editedItem.LINK_URL.length < 1){
          this.$alert(this.$t('adminbanner_msg9'));
          return;
        }
        */

        const imgflag = await this.checkimgupload(`팝업 이미지`, `IMAGE`);
        if(!imgflag){
          if(this.editedItem.IMAGE == null || this.editedItem.IMAGE == undefined || this.editedItem.IMAGE.length == 0){
            this.$alert(this.$t('adminbanner_msg5'));
            return;
          }
        }


        if (this.editedIndex > -1) {
          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/PageBannerUpdate',{
                COM_IDX: this.editedItem.COM_IDX
              , EVENT_IDX: this.editedItem.EVENT_IDX
              , TITLE: escape(this.editedItem.TITLE)
              , IMAGE: this.editedItem.IMAGE
              , STATE: this.editedItem.STATE
              , LAN_TYPE: this.editedItem.LAN_TYPE
              , LINK_URL: this.editedItem.LINK_URL == null || this.editedItem.LINK_URL == undefined ? '' : this.editedItem.LINK_URL
              , SORT: this.editedItem.SORT
              , STARTDATE: this.editedItem.STARTDATE
              , ENDDATE: this.editedItem.ENDDATE
              , PB_IDX: this.editedItem.PB_IDX
              , ADMIN_IDX: this.editedItem.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });          

        }else{
          //신규
          this.loading = true;
          this.$http.post(this.$host+'/api/PageBannerInsert',{
                COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , TITLE: escape(this.editedItem.TITLE)
              , IMAGE: this.editedItem.IMAGE
              , STATE: this.editedItem.STATE
              , LAN_TYPE: this.editedItem.LAN_TYPE
              , LINK_URL: this.editedItem.LINK_URL
              , SORT: this.itemList.length+1
              , STARTDATE: this.editedItem.STARTDATE
              , ENDDATE: this.editedItem.ENDDATE
              , PB_IDX: this.editedItem.PB_IDX
              , ADMIN_IDX:this.$session.get("ADMIN_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t('common_insert_msg')).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_insert_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_insert_fail"));
          });

        }

        this.close()  //팝업닫기
      },      

      //검색버튼 클릭
      search_run(){
        this.loadpage(1);
      },

      //신규 추가
      newinsert(){
        this.dialogTitle  = this.$t('common_insert_title');
        this.editedIndex  = -1;
        this.editedItem   = Object.assign({}, this.defaultItem);
        this.previewImg   = null;
        this.dialog = true;
      },

      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.previewImg = this.editedItem.IMAGE;
        this.dialog = true;
      },

      //아이템 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          
          this.loading = true;
          this.$http.post(this.$host+'/api/PageBannerDelete',{
                PB_IDX:item.PB_IDX
              , ADMIN_IDX:item.ADMIN_IDX
              , COM_IDX: item.COM_IDX
              , EVENT_IDX: item.EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              
              this.$alert(this.$t("common_delete_com")).then(()=>{
                const p = this.page;
                this.page = 0;
                this.loadpage(p);
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      
        });

      },

    },
  
}
</script>



<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>



</style>